// Profile Wishlist

const profileWishlist = document.querySelectorAll('[data-slider-parent] [data-slider="profile-wishlist-slider"]');

const profileWishlistOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

const initProfileWishlistSlider = (el) => {
  const parentEle = el.closest('[data-slider-parent]');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');

  const options = {
    ...profileWishlistOptions,
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
  };

  new Swiper(el, options);
};

profileWishlist.forEach((el) => initProfileWishlistSlider(el));

setupResponsiveSliders({
  sliderElements: profileWishlist,
  breakpoint: breakpointSm,
  initSlider: initProfileWishlistSlider,
  mobileFallback: [enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
